export default __webpack_public_path__ + "79b8d5b5a60059ce0380d4212bb9c8cd.png";